import React from 'react';
import './AllJobAdmin.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoaderBigTwo from '../../Shared/LoaderBigTwo/LoaderBigTwo';
import SubAllJobs from './SubAllJobs';
import SubArchive from './SubArchive';
import SubShortlisted from './SubShortlisted';
import SubPendingConfirmation from './SubPendingConfirmation';
import SubPendingVerification from './SubPendingVerification';
import SubFollowUpTutor from './SubFollowUpTutor';
import SubFollowUpGuardian from './SubFollowUpGuardian';
import SubClassBooked from './SubClassBooked';
import SubSentInvoice from './SubSentInvoice';
import SubDone from './SubDone';
import SubPendingPayment from './SubPendingPayment';
import SubUnshorted from './SubUnshorted';
import SubPendingTutions from './SubPendingTutions';

const AllJobAdmin = () => {
    const [activeTab, setActiveTab] = useState(1); // Set the default active tab to 2 (Tab 2)

    // Function to handle tab click
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    const [AllApplication, setAllApplication] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchArea = async () => {
        try {
            const response = await fetch('https://tutor-tree-server-1.vercel.app/allUsers');
            const data = await response.json();
            setAllApplication(data);
            setLoading(false)
        } catch (error) {
            console.error('Error fetching Districts:', error);
        }
    };

    useEffect(() => {
        fetchArea();
    }, []);



    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 16; // Set the number of items to display per page
    const maxPageButtons = 5; // Set the maximum number of pagination buttons to display

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = AllApplication.slice(indexOfFirstItem, indexOfLastItem);

    const totalPageCount = Math.ceil(AllApplication.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const generatePaginationButtons = () => {
        const pageButtons = [];
        let startPage = 1;
        let endPage = totalPageCount;

        if (totalPageCount > maxPageButtons) {
            if (currentPage <= Math.ceil(maxPageButtons / 2)) {
                endPage = maxPageButtons;
            } else if (currentPage > totalPageCount - Math.floor(maxPageButtons / 2)) {
                startPage = totalPageCount - maxPageButtons + 1;
            } else {
                startPage = currentPage - Math.floor(maxPageButtons / 2);
                endPage = currentPage + Math.floor(maxPageButtons / 2);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageButtons.push(
                <li key={i}>
                    <button
                        onClick={() => handlePageChange(i)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${currentPage === i ? 'text-blue-600 bg-blue-50' : ''
                            }`}
                    >
                        {i}
                    </button>
                </li>
            );
        }

        return pageButtons;
    };

    return (
        <div>
            <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
                <h2 className='headingTxt'>All Jobs</h2>
            </div>
            <div className='px-5 mt-5'>
                <div className='w-full grid grid-cols-5 gap-5 py-10'>
                    <button onClick={() => handleTabClick(1)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Pending Tuitions</button>
                    <button onClick={() => handleTabClick(2)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Unsorted</button>
                    <button onClick={() => handleTabClick(3)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Shortlisted</button>
                    <button onClick={() => handleTabClick(4)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Pending Confirmation</button>
                    <button onClick={() => handleTabClick(5)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Pending Verification</button>
                    <button onClick={() => handleTabClick(6)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Follow Up Tutor</button>
                    <button onClick={() => handleTabClick(7)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Follow Up Grudian</button>
                    <button onClick={() => handleTabClick(8)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Class Booked</button>
                    <button onClick={() => handleTabClick(9)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Send Invoice</button>
                    <button onClick={() => handleTabClick(10)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Pending Payment</button>
                    <button onClick={() => handleTabClick(11)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Pending Overdue</button>
                    <button onClick={() => handleTabClick(12)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Refunds</button>
                    <button onClick={() => handleTabClick(13)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>All Jobs</button>
                    <button onClick={() => handleTabClick(14)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Archive</button>
                    <button onClick={() => handleTabClick(15)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Done</button>
                </div>


                {/* Content for Tab 1 */}
                {activeTab === 1 && (
                    <div className="tab-content w-full">
                    <SubPendingTutions></SubPendingTutions>
                    </div>
                )}

                {/* Content for Tab 2 */}
                {activeTab === 2 && (
                    <div className='w-full'>
                    
                    <SubUnshorted></SubUnshorted>

                    </div>
                )}

                {/* Content for Tab 3 */}
                {activeTab === 3 && (
                    <div className='w-full'>
                       <SubShortlisted></SubShortlisted>
                    </div>
                )}
                {activeTab === 4 && (
                    <div className='w-full'>
                        <SubPendingConfirmation></SubPendingConfirmation>
                    </div>
                )}
                {activeTab === 5 && (
                    <div>
                        <SubPendingVerification></SubPendingVerification>
                    </div>
                )}
                {activeTab === 6 && (
                    <div>
                        <SubFollowUpTutor></SubFollowUpTutor>
                    </div>
                )}
                {activeTab === 7 && (
                    <div>
                        <SubFollowUpGuardian></SubFollowUpGuardian>
                    </div>
                )}
                {activeTab === 8 && (
                    <div>
                        <SubClassBooked></SubClassBooked>
                    </div>
                )}
                {activeTab === 9 && (
                    <div>
                        <SubSentInvoice></SubSentInvoice>
                    </div>
                )}
                {activeTab === 10 && (
                    <div>
                        <SubPendingPayment></SubPendingPayment>
                    </div>
                )}
                {activeTab === 11 && (
                    <div>
                        11
                    </div>
                )}
                {activeTab === 12 && (
                    <div>
                        
                    </div>
                )}
                {activeTab === 13 && (
                    <div className="tab-content w-full h-96 ">
                          <SubAllJobs></SubAllJobs>
                   </div>
                )}
                {activeTab === 14 && (
                    <div>
                        <SubArchive></SubArchive>
                    </div>
                )}
                {activeTab === 15 && (
                    <div>
                        <SubDone></SubDone>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllJobAdmin;